











































































import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
// import memberOrDeptSelect from '@/components/commonForm/memberOrDeptSelect.vue'
import widgetCommon from './widgetCommon'
import {selectE} from './types'
import {difference} from 'lodash'
import widgetPop from './widgetPop'
import {AppModule} from '@/store/modules/app'
import {UserModule} from '@/store/modules/user'
import { DynamicScroller } from 'vue-virtual-scroller'
import {getDynamicUser} from '@/apis/sheet'
const dynamic = ['createUser', 'createSuperior']
@Component({
  components: {
    DynamicScroller
    // memberOrDeptSelect
  }
})
export default class extends Mixins(widgetCommon, widgetPop) {
  private popupValue: any = ''
  private searchValue = ''
  private options: any = []
  private get currentSelect () {
    let values = this.form[this.item.businessId]
    if (values) {
      return values.split(',').map((item) => {
        return AppModule.workerMap[item]
      })
    }
    return []
  }
  private get popupValueArr () {
    if (!this.popupValue) {
      return []
    }
    let v: any = []
    if (this.item.selectType === selectE.radio) { 
      v = [this.popupValue]
    } else {
      v = this.popupValue
    }
    return v.map((item) => {
      return AppModule.workerMap[item]
    })
  }
  private get componentType () {
    return this.item.selectType === 2 ? 'van-checkbox' : 'van-radio'
  }
  private get members () {
    let list = this.options
    return list.filter((item) => {
      if (item.name.includes(this.searchValue)) {
        return true
      }
    })
  }
  public mounted () {
    if (this.type === 'record') {
       this.initField()
       // 所有字段都初始化后再获取动态字段的值
      //  this.$nextTick(() => {
      //    this.getDynamicValue()
      //  })
    }
  }
  private close (item) {
    if (this.item.selectType === selectE.radio) { 
      this.popupValue = ''
    } else {
      // 转化为字符串
      let id = item.id + ''
      let index = this.popupValue.indexOf(id)
      this.popupValue.splice(index, 1)
    }
  }
  private comfirm () {
    if (this.item.selectType === selectE.radio) { 
      this.form[this.item.businessId] = this.popupValue
    } else {
      this.form[this.item.businessId] = this.popupValue.join(',')
    }
    this.changeStatus(false)
  }
  private open () {
    if (this.disabled) {
      return 
    }
    this.changeStatus(true)
    this.filterWorkerList()
    if (this.item.selectType === selectE.radio) { 
      this.popupValue = this.form[this.item.businessId]
    } else {
      let v = this.form[this.item.businessId]
      this.popupValue = v ? v.split(',') : []
    }
  }
  private clear () {
    if (this.item.selectType === selectE.radio) { 
      this.popupValue = ''
    } else {
      let v = this.form[this.item.businessId]
      this.popupValue = []
    }
  }
  private filterWorkerList () {
    let {dept = [], diy = [], role = [], user = []} = this.item.optionalScope || {}
    if (dept.length || role.length || user.length || diy.length) {
      let diyList: any[] = []
      let userList: any[] = []
      let deptList: any[] = []
      diy.forEach((id) => {
        if (dynamic.includes(id)) {
          diyList.push(id)
        } else {
          let field = this.fieldsMap[id]
          if (field && field.fieldType === 'member') {
            let v = this.form[id] ? this.form[id].split(',').map((memberId) => Number(memberId)) : []
            userList = userList.concat(v)
          } else if (field) {
            let v = this.form[id] ? this.form[id].split(',').map((depId) => Number(depId)) : []
            deptList = deptList.concat(v)
          }
        }
      })
      let allDep = [...new Set([...deptList, ...dept])]
      let allUser = [...new Set([...userList, ...user])]
      let creator = this.state === 'add' ? UserModule.user.id : this.form.createUser
      getDynamicUser({optionalScope: {dept: allDep, role, diy: diyList}, creator}).then((res) => {
        let arr = [...new Set([...res.data, ...allUser])]
        this.options = arr.map((id) => {
          return AppModule.workerMap[id]
        })
      })
    } else {
      this.options = AppModule.workerList
    }
    
  }
  // private getDynamicValue () {
  //   let {dynamicValue = ''} = this.item.defaultValue || {}
  //   dynamicValue = dynamicValue ? dynamicValue.split(',') : []
  //   dynamicValue.forEach((businessId) => {
  //     this.$watch('form.' + businessId, (newV, oldV = '') => {
  //       if (this.isUndef(newV)) {
  //         return
  //       }
  //       newV = newV.split(',').filter(item => item)
  //       if (this.item.selectType === selectE.radio) {
  //         this.form[this.item.businessId] = newV[0] || ''
  //       } else {
  //         oldV =  oldV.split(',').filter(item => item)
  //         let remove: string[] = difference(oldV, newV)
  //         let value = this.form[this.item.businessId] || ''
  //         let valueArr = value.split(',').filter(item => item)
  //         newV.forEach((id) => {
  //           if (!valueArr.includes(id)) {
  //             valueArr.push(id)
  //           }
  //         })
  //         remove.forEach((id) => {
  //           let index = valueArr.indexOf(id)
  //           if (index !== -1) {
  //             valueArr.splice(index, 1)
  //           }
  //         })
  //         this.form[this.item.businessId] = valueArr.join(',')
  //       }
  //     }, {immediate: this.state === 'add'})  
  //   })
  // }
  private initField () {
    if (!this.isUndef(this.form[this.item.businessId])) {
      return
    }
    let {fixedValue = ''} = this.item.defaultValue || {}
    fixedValue = fixedValue ? fixedValue.split(',') : []
    if (this.item.selectType === selectE.radio) {
      this.form[this.item.businessId] = fixedValue[0] || ''
    } else {
      this.form[this.item.businessId] = fixedValue.join(',')
    }
  }
}
